<template>
  <div
    class="octadesk-app-messenger-overlay"
    :class="{
      open: overlayOpen
    }"
  ></div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters(['overlayOpen'])
    }
  }
</script>

<style scoped>
  .octadesk-app-messenger-overlay {
    position: absolute;
    z-index: 4;
    background-color: rgba(0, 0, 0, 0.5);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    pointer-events: none;
    opacity: 0;
    transition: opacity 400ms;
  }

  .octadesk-app-messenger-overlay.open {
    opacity: 1;
  }
</style>
